import { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';



const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <HeaderContainer>
      <Logo>
        <div className="logo-circle" />
        <span>DataVision Solutions</span>
      </Logo>
      <Nav>
        <Link to="/">Accueil</Link>
        <Link to="/about">Qui sommes-nous</Link>
        <Link to="/services">Services</Link>
        <Link to="/formation">Formation</Link>
        <Link to="/contact">Contact</Link>
      </Nav>

      <MenuButton onClick={() => setIsMenuOpen(!isMenuOpen)}>
        {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
      </MenuButton>

      <MobileNav isOpen={isMenuOpen}>

        <nav onClick={() => setIsMenuOpen(false)}>
          <Link to="/">Accueil</Link>
          <Link to="/about">Qui sommes-nous</Link>
          <Link to="/services">Services</Link>
          <Link to="/formation">Formation</Link>
          <Link to="/contact">Contact</Link>
        </nav>
      </MobileNav>

      <Button onClick={() => navigate('/contact')}>Contact</Button>
    </HeaderContainer>
  );
};

export default Header;



const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
    max-width: 100%;
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  
  .logo-circle {
    width: 2rem;
    height: 2rem;
    background: #3b82f6;
    border-radius: 50%;
  }
  
  span {
    font-size: 1.25rem;
    font-weight: bold;
  }
`;

const Nav = styled.nav`
 display: flex;
 gap: 2rem;
 position: absolute;
 left: 50%;
 transform: translateX(-50%);

 @media (max-width: 1300px) {
   display: none;
 }

 a {
   color: white;
   text-decoration: none;
   &:hover { color: #60a5fa; }
 }
`;
const Button = styled.button`
  background: #2563eb;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  cursor: pointer;
  &:hover { background: #1d4ed8; }

   @media (max-width: 1300px) {
   display: none;
 }
`;

const MobileNav = styled.div`
 display: none;

 @media (max-width: 1300px) {
   display: block;
   position: fixed;
   top: 10px;
   right: ${({ isOpen }) => (isOpen ? '20px' : '-100%')};
   width: 200px;
   height: auto;
   background: #3b82f6;
   padding: 1rem;
   border-radius: 10px;
   transition: right 0.3s ease;
   z-index: 1000;

   nav {
     display: flex;
     flex-direction: column;
     gap: 1rem;
   }

   a {
     color: white;
     text-decoration: none;
     padding: 0.5rem;
     &:hover { color: #60a5fa; }
   }
 }
`;

const MenuButton = styled.button`
 display: none;
 background: none;
 border: none;
 color: white;
 cursor: pointer;
 z-index: 1001;

 @media (max-width: 1300px) {
   display: block;
 }
`;
